"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPinView = void 0;
const assignIn_1 = __importDefault(require("lodash/assignIn"));
const noop_1 = __importDefault(require("lodash/noop"));
class MapPinView {
    constructor(object, position, map) {
        this.object = object;
        (0, assignIn_1.default)(MapPinView.prototype, google.maps.Marker.prototype, google.maps.OverlayView.prototype, 
        // Remove add,remove,draw functions
        {
            onAdd: noop_1.default,
            onRemove: noop_1.default,
            draw: noop_1.default,
        });
        google.maps.Marker.call(this, { position, map });
        google.maps.OverlayView.call(this);
    }
    select() {
        google.maps.event.trigger(this, 'select');
    }
    deselect() {
        google.maps.event.trigger(this, 'deselect');
    }
}
exports.MapPinView = MapPinView;
//# sourceMappingURL=MapPinView.js.map